import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const LocalCodeWrapper = styled.div`
    color: ${getPurpurColor('purple500')};
    font-size: ${getPurpurTypography('scale50')};
    font-weight: ${getPurpurTypography('weightNormal')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
    margin: ${getPurpurSpacing('100')} 0;
`;

export const LocalCodeContent = styled.span`
    user-select: all;
`;

export const ContentWrapper = styled.div`
    margin-bottom: ${getPurpurSpacing('250')};
`;
